import React from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';

const ItemInput = ({ params, errors, onChange, canAddItem, addItem }) => (
  <Row>
    <Col>
      <Form.Group>
        <Form.Label>Item Description</Form.Label>
        <Form.Control
          name="name"
          value={params.name}
          onChange={onChange}
          required
          isInvalid={errors.name}
        />
      </Form.Group>
    </Col>
    <Col>
      <Form.Group>
        <Form.Label>QTY</Form.Label>
        <Form.Control
          name="qty"
          type="number"
          value={params.qty}
          onChange={onChange}
          min={1}
        />
      </Form.Group>
    </Col>
    <Col>
      <Form.Group>
        <Form.Label>UOM</Form.Label>
        <Form.Control name="uom" value={params.uom} onChange={onChange} />
      </Form.Group>
    </Col>
    <Col>
      <Form.Group>
        <br />
        <Button onClick={addItem} disabled={canAddItem}>
          ADD ITEM
        </Button>
      </Form.Group>
    </Col>
  </Row>
);

export default ItemInput;
